<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-form-stack">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['code']"></astral-input>
          <astral-input [control]="form.controls['name']"></astral-input>
        </astral-layout-group>

        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-select [control]="form.controls['unit']" [itemsSource]="unitSelection"></astral-select>
          <app-money-box class="astral-layout-item" [control]="form.controls['amount']"></app-money-box>
        @if (isInvoicing) {
          <app-money-box class="astral-layout-item" [control]="form.controls['startCost']"></app-money-box>
        }
          @if (isInvoicing) {
            <astral-select [control]="form.controls['vatPercent']" [itemsSource]="vatPercentages"></astral-select>
          }
        </astral-layout-group>

      @if (isInvoicing) {
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-select [control]="form.controls['componentCategory']" [itemsSource]="componentCategorySelection"></astral-select>
          @if (showComponentType) {
            <astral-select [control]="form.controls['componentType']" [itemsSource]="componentTypeSelection"></astral-select>
          }
          <astral-select [control]="form.controls['customProperty']" [itemsSource]="customPropertySelection"></astral-select>
        </astral-layout-group>
      }
      </section>

      @for (codingForm of $any(codingForms.controls); track codingForm) {
        <section class="astral-section-surface astral-stack-m">
          @if (codingForms.controls.length > 1) {
            <h4>{{ codingForm.controls['accountPlanName'].value }}</h4>
          }
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
              <astral-select
                [control]="codingForm.controls['incomeAccountId']"
                [itemsSource]="getIncomeAccountSelection(codingForm.controls['accountPlanId'].value)"
                [helpText]="'PRICELIST.HELP_TEXT.INCOME_ACCOUNT'"
              ></astral-select>
            @if (showPriceListItemCostPlace(codingForm.controls['accountPlanId'].value)) {
              <astral-input [control]="codingForm.controls['costPlace']"></astral-input>
            }
            @if (showPriceListItemFunction(codingForm.controls['accountPlanId'].value)) {
              <astral-input [control]="codingForm.controls['function']"></astral-input>
            }
          </astral-layout-group>
        </section>
      }
    </form>
  }
</section>
